export const storageService = {
    setToken: (token) => {
      localStorage.setItem('token', token);
    },
    
    getToken: () => {
      return localStorage.getItem('token');
    },
    
    setUser: (user) => {
      localStorage.setItem('user', JSON.stringify(user));
    },
    
    getUser: () => {
      const userData = localStorage.getItem('user');
      return userData ? JSON.parse(userData) : null;
    },
    
    clearAuth: () => {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
    }
  };